import { GraphUtils } from '@helpers/graph.helper';
import { Sensor } from '../sensor/sensor';
import { Router } from '@angular/router';
import { UtilsHelper } from '@helpers/utils.helper';

export class DepthAttribute extends Sensor {
  public depthChart: any;
  private depthSensor: any[];
  public iconsToDisplay: { icon: string, type: number }[] = [];

  constructor(router: Router, url: string, alertsActive: boolean) {
    super(router, url, alertsActive);
    this.depthChart = null;
    this.depthSensor = [];
  }

  private ensureArraySize(arr: any[], position: number): void {
    while (arr.length <= position) {
      arr.push([]);
    }
  }

  public prepareData(): void {
    const iconMap = new Map<string, { icon: string, type: number }>();
    for (const element of this.data) {
      const date = new Date(element.date);
      const timestamp = GraphUtils.getDateUtc(date);
      const position = element.position;
      const sensorInfo = UtilsHelper.nameSensor(element.type);
      const icon = sensorInfo.icon;
      if (!iconMap.has(icon)) {
        iconMap.set(icon, {
          icon,
          type: element.type
        });
      }

      this.ensureArraySize(this.depthSensor, position);
      this.depthSensor[position].push([timestamp, element.depth]);
    }
    this.iconsToDisplay = Array.from(iconMap.values());
  }

  public setCharts(): void {
    const filteredDepth = this.depthSensor.filter(series => series.length > 0);

    const positionNodeDepth = this.depthSensor
      .map((item, index) => (item.length > 0 ? index + 1 : -1))
      .filter(index => index !== -1);

    this.depthChart = this.getConfigChar(
      'depth',
      this.getChartSeriesNewNode('Sensor', filteredDepth, positionNodeDepth),
      this.getRanges('depth'),
      this.getLimits('depth')
    );
  }

  public hasDepthSensor(pos: number): boolean {
    const index = pos - 1;
    return (
      index >= 0 &&
      index < this.depthSensor.length &&
      this.depthSensor[index].length > 0
    );
  }

  public getDepthSensor(pos: number): any {
    const index = pos - 1;
    if (index >= 0 && index < this.depthSensor.length) {
      const sensorData = this.depthSensor[index];
      if (sensorData.length > 0) {
        return sensorData[sensorData.length - 1][1] ?? null;
      }
    }
    return null;
  }

  public static getVariables(): any[] {
    return [
      { title: 'Profundidad', value: 'depth' }
    ];
  }
}
